/* eslint-disable security/detect-eval-with-expression */
/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React, { useContext } from 'react';
import AnimatedButton from '../../components/Button';
import './welcome.css';
import ApplicationContext from '../../context/ApplicationContext';
import AnimatedImage from '../../components/Animations/AnimatedImage';
import { welcomeLanguageContent } from './welcomeLanguageContent';

function Welcome() {
    const { facilityData, handlePage, selectedLanguage } = useContext(ApplicationContext);

    // const launchScript = () => {
    //     // Directly include the script content within the function
    //     const scriptContent =<script id="oada_ma_toolbar_script">var oada_ma_license_key="o0y0FeiEOcxWvKDcWLKg42ORSaddoWj4OIQ3mSMawXwPZzMex9";var oada_ma_license_url="https://api.maxaccess.io/scripts/toolbar/o0y0FeiEOcxWvKDcWLKg42ORSaddoWj4OIQ3mSMawXwPZzMex9";(function(s,o,g){a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.src=g;a.setAttribute("async","");a.setAttribute("type","text/javascript");a.setAttribute("crossorigin","anonymous");m.parentNode.insertBefore(a,m)})(document,"script",oada_ma_license_url+oada_ma_license_key);</script>
        
    //     // Execute the script using eval
    //     try {
    //         eval(scriptContent);
    //     } catch (error) {
    //         console.error('Error executing script:', error);
    //     }
    // };
    
    return (
        <div className='flex flex-col justify-between relative h-welcome'>
            <div className='p-[8px]'>
                {welcomeLanguageContent['welcome'][selectedLanguage]}
                <div className='flex justify-center mt-[67px]'>
                    <AnimatedButton handleClick={() => handlePage('nameVerify')} disabled={false} id="continue_button" className={`font-semibold
                    text-gray w-[200px] h-[40px] pl-[41px] text-[16px] md:text-[18px] lg:text-[18px] xl:text-[18px] 2xl:text-[18px] justify-center`}>
                        <p className={selectedLanguage === 'ar' ? 'dir-rtl' : ''}>{welcomeLanguageContent['continue'][selectedLanguage]}</p>
                        <img src="/images/next.svg" alt="next" className='ml-[1.2em] w-[1.7em] h-[1.7em]' />
                    </AnimatedButton>
                </div>
            </div>
            <div className='landscape'>
                <div data-testid="banner" className='flex rounded-b-[12px] relative justify-center bg-no-repeat h-[200px] bg-cover sm:bg-center lg:bg-center lg:h-[255px] xl:h-[320px] 2xl:h-[420px] md:h-[300px]' 
                    style={{width: '-webkit-fill-available', backgroundImage: `url(${facilityData.facility_banner || '/images/frame.jpg'})`}}>
                    <div className="overlay opacity-[60%] absolute"></div>
                    <div className='flex justify-center items-center gap-[60px] z-[9]'>
                        <div data-testid="choose_help_language" onClick={() => handlePage('choose_language', '', '', '')} className='px-[14px] py-[19px] blue-shadow rounded-lg bg-white border border-[#797979] w-[105px] flex flex-col items-center cursor-pointer'>
                            <AnimatedImage url="/images/language.svg" alt="language" />
                            <p className={`font-normal text-sm text-gray ${selectedLanguage === 'ar' ? 'dir-rtl' : ''}`}>{welcomeLanguageContent['language'][selectedLanguage]}</p>
                        </div>
                        <div className='px-[14px] py-[19px] blue-shadow rounded-lg bg-white border border-[#797979] w-[105px] flex flex-col items-center'>
                            <AnimatedImage url="/images/accessibility.svg" alt="language" />
                            <p onClick={() => launchScript()} className={`font-normal text-sm text-gray mt-1.5 ${selectedLanguage === 'ar' ? 'dir-rtl' : ''}`}>{welcomeLanguageContent['options'][selectedLanguage]}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Welcome;